import { createRouter, createWebHashHistory } from 'vue-router';
// Opcional: Importa un componente para mostrar cuando la ruta no exista
// import NotFound from '@/lib/NotFound.vue'; 

const routes = [
  // Tu ruta base u otras rutas estáticas
  { path: '/', component: () => import('@/app/xindex.vue') }, 
  // Puedes añadir más rutas estáticas aquí si las necesitas
];

// --- Creación dinámica de rutas ---

// 1. Usa import.meta.glob para encontrar todos los archivos .vue en src-js/app
//    El '!' al inicio excluye los archivos que empiezan con 'x'.
//    `eager: false` (por defecto) crea importaciones dinámicas `() => import(...)`
const pages = import.meta.glob('@/app/!x*.vue'); 

// 2. Itera sobre los módulos encontrados para crear las rutas
for (const page in pages) {
  // Extrae el nombre del archivo sin la extensión .vue
  // Ejemplo: page = '/src-js/app/MiPagina.vue' -> fileName = 'MiPagina'
  const file = page.match(/\/([^/]+)\.vue$/);

  if (file && file[1]) {
    const pageName = file[1];
    // Convierte el nombre a minúsculas para la ruta URL (práctica común)
    const routePage = `/${pageName.toLowerCase()}`; 

    // Ruta principal para la página: /mipagina
    routes.push({
      path: routePage,
      name: pageName, // Nombre de la ruta (útil para navegación programática)
      component: pages[page], // La función de importación dinámica
    });

    // Ruta con parámetro :id -> /mipagina/:id
    routes.push({
      path: `${routePage}/:id`,
      name: `${pageName}-id`, // Nombre único para la ruta con parámetro
      component: pages[page], 
      props: true // Pasa automáticamente los parámetros de ruta como props al componente
    });

    // Manejo específico como tu ejemplo de Recibos
    if (pageName === 'Recibos') {
       routes.push({
         path: `${routePage}/pendienteshoy/:num`, // /recibos/pendienteshoy/:num
         name: `${pageName}-PendientesHoy`,
         component: pages[page],
         props: true,
       });
    }
  }
}

// --- Fin de la creación dinámica ---

// 3. (Opcional pero recomendado) Añade una ruta "catch-all" para páginas no encontradas (404)
// routes.push({ 
//   path: '/:pathMatch(.*)*', // Coincide con cualquier cosa no definida antes
//   name: 'NotFound',
//   component: NotFound // Tu componente 404
// });

const router = createRouter({
  history: createWebHashHistory(),
  routes, // Usa el array de rutas que ahora incluye las dinámicas
});

export default router;
